import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo2/bodega.png";
import Imagen2 from "../../../images/modulo2/plaza.png";
import Imagen3 from "../../../images/modulo2/cremoladas.png";
import Imagen4 from "../../../images/modulo2/mercado.png";
import Imagen5 from "../../../images/modulo2/kiosko.png";
import Imagen6 from "../../../images/modulo2/panaderia.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo2 } from "../../../routes/Module2";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo2/Actividad 2.mp3";

const Actividad2 = () => {
  const infoUnidad = modulo2.content[0];
  const infoAct = modulo2.content[0].activities[1];
  const crumbs = [
    {
      title: modulo2.title,
      url: "/" + modulo2.url,
    },
    {
      title:
        modulo2.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo2.content[0].activities[2].name}`,
    linkNext: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[2].path}`,
    titlePrev: `${modulo2.content[0].activities[0].name}`,
    linkPrev: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[0].path}`,
  };
  const metadata = {
    color: modulo2.color,
    title: `${modulo2.title} - ${infoAct.name}`,
    name: modulo2.title
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo2.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">Actividad 2</h2>
      <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-md-10 col-sm-12 mb-5">
          <ul>
            <li>
              Todos los días, compartimos espacios en nuestros barrios con
              nuestros vecinos y vecinas.
            </li>
            <li>
              Marca con un check (✓) los lugares que frecuentas en tu distrito o
              barrio.
            </li>
            <li>
              Compara tus respuestas con las de un compañero, compañera o
              familiar.
            </li>
          </ul>
        </div>
      </div>
      <div className="row activities-content mt-1">
        <div className="col-lg-4 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <input
              className="form-check-input mb-1 form-md"
              type="checkbox"
              id="checkboxNoLabel"
              value=""
              aria-label="..."
            />
          </div>
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-4 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <input
              className="form-check-input mb-1 form-md"
              type="checkbox"
              id="checkboxNoLabel"
              value=""
              aria-label="..."
            />
          </div>
          <img src={Imagen2} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-4 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <input
              className="form-check-input mb-1 form-md"
              type="checkbox"
              id="checkboxNoLabel"
              value=""
              aria-label="..."
            />
          </div>
          <img src={Imagen3} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-4 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <input
              className="form-check-input mb-1 form-md"
              type="checkbox"
              id="checkboxNoLabel"
              value=""
              aria-label="..."
            />
          </div>
          <img src={Imagen4} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-4 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <input
              className="form-check-input mb-1 form-md"
              type="checkbox"
              id="checkboxNoLabel"
              value=""
              aria-label="..."
            />
          </div>
          <img src={Imagen5} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-4 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <input
              className="form-check-input mb-1 form-md"
              type="checkbox"
              id="checkboxNoLabel"
              value=""
              aria-label="..."
            />
          </div>
          <img src={Imagen6} alt="Familia" className="img-fluid" />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y dialoguen acerca de los
          lugares representados en ellas. Resalte que los barrios y distritos
          cuentan con lugares a los que van diversas personas, algunas viven
          allí y otras vienen de otros barrios y distritos.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
